<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.1214 16L26.0608 8.06065L23.9395 5.93933L16.0001 13.8787L8.06079 5.93933L5.93947 8.06065L13.8788 16L5.93945 23.9393L8.06077 26.0606L16.0001 18.1213L23.9395 26.0606L26.0608 23.9393L18.1214 16Z" />
    </svg>
  </template>
  
<script>
export default {
  name: "RemovalX",
};
</script>
  